<template>
  <section class="section columns">
    <div
      class="box login container column is-one-third profileContainer"
      :class="{ 'is-loading': updatingUser }"
    >
      <form ref="profileForm" @submit.prevent="updateUser">
        <div class="field">
          <label class="label has-text-left has-text-weight-semibold">First Name</label>

          <input
            type="text"
            name="firstname"
            placeholder="First Name"
            v-model="user.first_name"
            class="input is-info"
          >
        </div>
        <label class="label has-text-left has-text-weight-semibold">Last Name</label>

        <div class="field">
          <input
            type="text"
            name="lastname"
            placeholder="Last Name"
            v-model="user.last_name"
            class="input"
          >
        </div>
        <div class="field">
          <label class="label has-text-left has-text-weight-semibold">Email</label>

          <input type="email" placeholder="Email" disabled v-model="user.email" class="input">
        </div>
        <div class="field">
          <label class="label has-text-left has-text-weight-semibold">Primary Contact</label>

          <input
            type="text"
            name="primary_contact"
            placeholder="Primary Contact"
            v-model="user.primary_contact"
            class="input"
          >
        </div>
        <div class="field">
          <label class="label has-text-left has-text-weight-semibold">Secondary Contact</label>

          <input
            type="text"
            name="secondary_contact"
            placeholder="Secondary Contact"
            v-model="user.secondary_contact"
            class="input"
          >
        </div>
        <div class="field">
          <label class="label has-text-left has-text-weight-semibold">Biography</label>

          <textarea name="biography" placeholder="Biography" v-model="user.bio" class="textarea"></textarea>
        </div>
        <div class="field">
          <label class="label has-text-left has-text-weight-semibold">Date of Birth</label>

          <input
            type="date"
            name="birth_date"
            placeholder="D.O.B"
            v-model="user.birth_date"
            id="birth_date"
            class="input"
          >
        </div>
        <div class="field v-upload">
          <label>Profile image</label>
          <div class="file has-name is-fullwidth">
            <label class="file-label">
              <input
                class="file-input"
                id="select-file"
                name="profile-picture"
                type="file"
                :prevent="true"
              >
            </label>
          </div>
          <div
            class="v-upload-preview-container"
            id="vUploadPreviewContainer"
            :style="setImagePreview(file)"
          >
            <span v-if="file.name !== null">{{ file.name }}</span>
          </div>
        </div>
        <button class="button v-upload-trigger" id="vUploadTrigger" @click.prevent>Choose a picture</button>

        <div>
          <button
            icon="far fa-save"
            :centered="false"
            :prevent="true"
            class="button"
            @click.native="updateUser"
          >Update Profile</button>
        </div>
      </form>
      <!-- <button class="button" @click.prevent="resetHasLoggedIn">Reset has_logged_in</button> -->
    </div>
  </section>
</template>

<script>
import { UserClient } from "../clients/UserClient.js";
import VueUpload from "../plugins/VueUpload.js";
import Vue from "vue";
import VueCookie from "vue-cookie";

Vue.use(VueUpload);

export default {
  name: "Profile",
  data: function() {
    return {
      user: this.$store.state.auth.user,

      file: this.$store.state.auth.user.profileUrl,
      base64: null,
      updatingUser: false
    };
  },
  mounted() {
    setTimeout(() => {
      VueUpload.configure({
        inputName: "file",
        target: document.getElementById("select-file"),
        triggerWith: document.getElementById("vUploadTrigger"),
        previewContainer: document.getElementById("vUploadPreviewContainer"),
        fileTypes: ["image/png", "image/jpeg"],
        events: {
          onError: (files, length, error) => {
            alert(error);
          },
          onChange: (file, files, reader) => {
            this.file = file;
            reader.onload = () => {
              this.base64 = reader.result;
              this.file.base64 = reader.result;
            };
          }
        }
      });
    }, 1000);
  },
  methods: {
    resetHasLoggedIn() {
      // UserClient.setHasLoggedIn().then(response => {
      //   this.$store.state.auth.user.has_logged_in = false;
      // });
      this.user.id_number = null;
      UserClient.updateUser(this.user);
    },
    logOut() {
      this.$store.state.auth.user = null;
      VueCookie.delete("access_token");
    },
    updateUser() {
      this.user.file = this.file.base64;
      console.log(this.file);
      console.log(this.$store.state.auth.user.profileUrl);
      this.updatingUser = true;
      UserClient.updateUser(this.user)
        .then(response => {
          console.log(response);
          this.updatingUser = false;
        })
        .catch(error => {
          console.log(error);
          this.updatingUser = false;
        });
    },
    setImagePreview(file) {
      let previewImage = this.file;
      if (this.base64 !== null) {
        previewImage = this.base64;
      }
      return "background-image: url(" + previewImage + ");";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

@import "../assets/scss/profile";
</style>
